import { useTranslation } from "react-i18next";

export default function TenderTaskSwitcher({ value, onChange }) {
  const { t } = useTranslation();
  const isTenders = value === "tenders";

  return (
    <div className="flex items-center gap-3 me-5">
      <button
        type="button"
        onClick={() => onChange("tenders")}
        className={`text-sm font-semibold tracking-[0.02em] ${
          isTenders ? "text-[#1E1E1E]" : "text-gray-400"
        }`}
      >
        {t("tenderTaskSwitcher.tenders")}
      </button>

      {/* Switch */}
      <button
        type="button"
        onClick={() => onChange(isTenders ? "tasks" : "tenders")}
        className="relative inline-flex h-4 w-8 items-center rounded-full bg-[#3D6C50] transition-colors"
      >
        <span
          className={`inline-block h-3 w-3 rounded-full bg-white shadow-sm transform transition-transform ${
            isTenders ? "translate-x-1" : "translate-x-4"
          }`}
        />
      </button>

      <button
        type="button"
        onClick={() => onChange("tasks")}
        className={`text-sm font-semibold tracking-[0.02em] ${
          !isTenders ? "text-[#1E1E1E]" : "text-gray-400"
        }`}
      >
        {t("tenderTaskSwitcher.tasks")}
      </button>
    </div>
  );
}
